import icons from 'url:../../img/icons.svg';


export default class View {
  _data;
  render(data, render = true) {
    if (!data || (Array.isArray(data) && data.length === 0))
      return this.renderError();

    this._data = data;
    const markup = this._generateMarkup();

    if (!render) return markup;

    this._clear();
    this._parentElemnt.insertAdjacentHTML('afterbegin', markup);
  }


  _clear() {
    this._parentElemnt.innerHTML = '';
  }

  renderError(message = this._erroMessage) {
    const markup = `
     <div class="error">
            <p>${message}</p>
          </div>`;
    this._clear();
    this._parentElemnt.insertAdjacentHTML('afterbegin', markup);
  }

  renderMessage(message = this._message) {
    const markup = `
     <div class="message">
            <p>${message}</p>
          </div>`;
    this._clear();
    this._parentElemnt.insertAdjacentHTML('afterbegin', markup);
  }

  renderSpinner() {
    const markup = `
  <div class="spinner">
          <svg>
            <use href="${icons}#icon-loader"></use>
          </svg>
        </div>`;
    this._clear();
    this._parentElemnt.insertAdjacentHTML('afterbegin', markup);
  }
}
